export const ROUTES = {
  DASHBOARD: '/',
  ROSTER: '/roster',
  PROGRAM: '/program',
  WATCHLIST: '/watchlist',
  STUDENT_DETAIL: '/student/:id'
} as const;
